<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <app-sub-title
                    text="Servicios de guardaespalda"
                ></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3" lg="2">
                <b-button
                    variant="primary"
                    class="btn-block"
                    @click="validateOpenService"
                    ><i class="fa fa-plus"></i> Iniciar servicio</b-button
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-btn variant="link" v-b-toggle.bodyguard-service-filters
                    >Filtros</b-btn
                >
                <b-collapse id="bodyguard-service-filters">
                    <app-bodyguard-services-filters @filter="onFilter" />
                </b-collapse>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-services-list
                    :data="data"
                    @change-page="changePage"
                    @remove-service="startRemove"
                    @login-service="loginService"
                    @see-card-service="seeCardService"
                    @sort="onSort"
                    @update="startEditing"
                />
            </b-col>
        </b-row>

        <!-- inicio de pop ups -->
        <app-pop-up
            title="Formulario servicio"
            id="bodyguard-service-form"
            :onClose="clearForm"
            size="large"
        >
            <div class="body" slot="body">
                <app-bodyguard-service-form
                    :myService="selectedBodyguardService"
                    id="bodyguard-service-form"
                    :onSave="onSave"
                    :edit="edit"
                    :longitude="longitude"
                    :latitude="latitude"
                />
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    class="btn-block-xs-only"
                    @click="$bus.$emit('bodyguard-service.save')"
                    :disabled="inProgress"
                    ><i class="fa fa-floppy-o"></i> Iniciar servicio</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="bodyguard-service-remove">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea eliminar este servicio de
                    guardaespalda?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteBodyguardService(selectedBodyguardService)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Servicio de guardaespalda"
            size="large"
            id="card-service"
        >
            <div slot="body">
                <app-bodyguard-service-card
                    :bodyguardService="selectedBodyguardService"
                />
            </div>
        </app-pop-up>

        <!-- Edición de servicio de escolta -->
        <app-pop-up
            title="Fomulario de servicio de escolta"
            id="bodyguard-service-window"
            :on-close="clearForm"
            size="large"
        >
            <template slot="body">
                <app-bodyguard-service-form-vehicular
                    v-if="form === 'appBodyguardServiceFormVehicular'"
                    :service="selectedService"
                    bodyguard-photo=""
                    :gun-photos="[]"
                    :onSave="onUpdate"
                    ref="bodyguardServiceForm"
                />
                <app-bodyguard-service-form-personal
                    v-if="form === 'appBodyguardServiceFormPersonal'"
                    :service="selectedService"
                    bodyguard-photo=""
                    :gun-photos="[]"
                    :onSave="onUpdate"
                    ref="bodyguardServiceForm"
                />
                <!-- <component
                    :is="form"
                    :service="selectedService"
                    bodyguard-photo=""
                    :gun-photos="[]"
                    :onSave="onUpdate"
                    ref="bodyguardServiceForm"
                    :key="Math.round(Math.random() * 10000000000)"
                ></component> -->
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="confirmUpdate"
                    ><i class="fa fa-save"></i> Guardar</b-btn
                >
            </template>
        </app-pop-up>
        <!-- Fin pop up's -->
    </b-container>
</template>

<script>
import BodyguardServicesList from './BodyguardServicesList/BodyguardServicesList'
import BodyguardServicesFilters from './BodyguardServicesFilters/BodyguardServicesFilters'
import BodyguardServiceForm from './BodyguardServiceForm/BodyguardServiceForm'
import BodyguardServiceCard from './BodyguardServiceCard/BodyguardServiceCard'
import storesRepository from '../../../../repositories/bodyguard.repository'
import { mapMutations, mapGetters } from 'vuex'
import * as mutations from '../../../../store/commitTypes'
import bodyguardRepository from '../../../../repositories/bodyguard.repository'
import BodyguardServiceFormVehicular from './BodyguardServiceForm/BodyguardServiceFormVehicular'
import BodyguardServiceFormPersonal from './BodyguardServiceForm/BodyguardServiceFormPersonal'

export default {
    components: {
        appBodyguardServicesList: BodyguardServicesList,
        appBodyguardServicesFilters: BodyguardServicesFilters,
        appBodyguardServiceForm: BodyguardServiceForm,
        appBodyguardServiceCard: BodyguardServiceCard,
        appBodyguardServiceFormVehicular: BodyguardServiceFormVehicular,
        appBodyguardServiceFormPersonal: BodyguardServiceFormPersonal,
    },
    data() {
        return {
            data: {},
            filters: {},
            page: 1,
            sort: {
                sortBy: 'end_date',
                sortDir: 'desc',
            },
            edit: false,
            longitude: '',
            latitude: '',
            selectedService: '',
            form: '',
        }
    },
    computed: {
        ...mapGetters(['selectedBodyguardService']),
    },
    methods: {
        ...mapMutations({
            setSelectedBodyguardService:
                mutations.SET_SELECTED_BODYGUARD_SERVICE,
        }),
        loadBodyguardServicesByUser() {
            const br = { ...bodyguardRepository }
            const filters = {
                ...this.filters,
                user: this.user.id,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            br.loadBodyguardServices(filters, this.page)
                .then(({ data }) => (this.data = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los servicios de guardaespalda'
                    )
                )
        },
        async validateOpenService() {
            const br = { ...bodyguardRepository }
            try {
                const {
                    data: { service },
                } = await br.hasOpenServices(this.user.id)

                if (!service) return this.startService()

                this.setSelectedBodyguardService(service)
                this.$router.push({ name: 'activeBodyguardServicePage' })
                toastr.error(
                    'Debe finalizar el último turno antes de iniciar uno nuevo'
                )
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al validar los servicios en curso [${err.message}]`
                )
            }
        },
        startService() {
            this.setSelectedBodyguardService(null)
            this.edit = false

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.longitude = position.coords.longitude.toString()
                    this.latitude = position.coords.latitude.toString()
                })
            } else {
                toastr.error('Navegador no compatible con geolocalización')
            }

            this.$bus.$emit('bodyguard-service-form.open')
            this.$bus.$emit('bodyguard-photo.on')
        },
        onFilter(filters) {
            this.filters = filters
            this.loadBodyguardServicesByUser()
        },
        changePage(page) {
            this.page = page
            this.loadBodyguardServicesByUser()
        },
        startRemove(service) {
            this.setSelectedBodyguardService(service)
            this.$bus.$emit('bodyguard-service-remove.open')
        },
        deleteBodyguardService(bodyguardService) {
            const br = { ...bodyguardRepository }
            br.deleteBodyguardService(bodyguardService.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadBodyguardServicesByUser()
                        this.$bus.$emit('bodyguard-service-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'No se pudo borrar el servicio de guardaespalda'
                    )
                })
        },
        loginService(service) {
            this.setSelectedBodyguardService(service)
            this.$router.push({ name: 'activeBodyguardServicePage' })
        },
        seeCardService(service) {
            this.setSelectedBodyguardService(service)
            this.$bus.$emit('card-service.open')
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadBodyguardServicesByUser()
        },
        onSave(service) {
            this.$bus.$emit('bodyguard-service-form.close')
            this.setSelectedBodyguardService(service)
            this.$router.push({ name: 'activeBodyguardServicePage' })
        },
        initialize() {
            this.loadBodyguardServicesByUser()
            this.setSelectedBodyguardService(null)
        },
        startEditing(service) {
            this.selectedService = service
            const components = {
                vehicular: 'appBodyguardServiceFormVehicular',
                personal: 'appBodyguardServiceFormPersonal',
            }
            this.form = components[service.type]
            this.$bus.$emit('bodyguard-service-window.open')
        },
        onUpdate(data) {
            this.clearForm()
            this.$bus.$emit('bodyguard-service-window.close')
            this.loadBodyguardServicesByUser()
        },
        clearForm() {
            this.selectedService = null
            this.$bus.$emit(`${this.form}.clearForm`)
            // this.$refs.bodyguardServiceForm.clearForm();
        },
        confirmUpdate() {
            this.$refs.bodyguardServiceForm.saveService()
        },
    },
    created() {
        this.initialize()
    },
}
</script>

<style></style>
